/* HeyBear core: shared helpers used by every hb- section.
   Section scripts register with HB.section('name', init). init(el) runs once per section element,
   again after the theme editor re-renders a section, and may return a cleanup function. */
(function () {
  'use strict';
  var HB = window.HB = window.HB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  HB.$ = $; HB.$$ = $$;
  HB.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  HB.fine = matchMedia('(pointer:fine)').matches;
  HB.routes = window.HB_ROUTES || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', account: '/account' };
  HB.K3 = { cola: 'sour-cola', apple: 'sour-apple', grape: 'sour-grape', strawberry: 'strawberry', watermelon: 'sour-watermelon' };
  HB.mixBg = 'linear-gradient(135deg,#D9B793 0 25%,#C9E4A6 25% 50%,#CBBBEA 50% 75%,#F2BDB8 75%)';
  HB.emailOk = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };

  /* ---------- data (rendered by snippets/hb-flavour-data.liquid inside the header) ---------- */
  var _data = null;
  HB.data = function () {
    if (_data) return _data;
    var el = document.getElementById('hb-data');
    try { _data = el ? JSON.parse(el.textContent) : {}; } catch (e) { _data = {}; console.warn('[HeyBear] Could not read #hb-data', e); }
    _data.flavours = (_data.flavours || []).slice().sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
    _data.upsells = _data.upsells || [];
    _data.cartons = _data.cartons || [];
    _data.mix = _data.mix || null;
    _data.byKey = {};
    _data.flavours.forEach(function (f) { _data.byKey[f.key] = f; });
    return _data;
  };
  HB.flavour = function (key) { return HB.data().byKey[key]; };
  /* variant helpers */
  HB.bags = function (variant) { var m = /(\d+)/.exec((variant && variant.title) || ''); return m ? +m[1] : 0; };
  HB.variantByBags = function (product, n) { return ((product && product.variants) || []).filter(function (v) { return HB.bags(v) === n; })[0] || null; };
  HB.variantMatch = function (product, re) { return ((product && product.variants) || []).filter(function (v) { return re.test(v.title); })[0] || null; };
  HB.primaryVariant = function (product) {
    var variants = (product && product.variants) || [];
    return variants.filter(function (v) { return v.role === 'three_pack' || /-3$/i.test(v.sku || '') || HB.bags(v) === 3; })[0] || variants[0] || null;
  };
  HB.productByKey = function (list, key) { return (list || []).filter(function (p) { return p.key === key; })[0] || null; };

  /* cart settings (rendered by sections/hb-cart-drawer.liquid) */
  var _cfg = null;
  HB.config = function () {
    if (_cfg) return _cfg;
    var el = document.getElementById('hb-cart-config');
    try { _cfg = el ? JSON.parse(el.textContent) : {}; } catch (e) { _cfg = {}; }
    _cfg.freeAt = typeof _cfg.freeAt === 'number' ? _cfg.freeAt : 9500; /* cents */
    return _cfg;
  };

  /* ---------- format Shopify cents using the approved storefront money style ---------- */
  HB.fmt = function (n) { n = Math.round(n * 100) / 100; return '$' + (Number.isInteger(n) ? n : n.toFixed(2)); };
  HB.money = function (cents) { return HB.fmt((cents || 0) / 100); };

  /* ---------- toast ---------- */
  var toastT;
  HB.toast = function (msg, ms) {
    var t = $('#toast'); if (!t) return;
    var tx = $('#toastText'); if (tx) tx.textContent = msg;
    t.classList.add('show'); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('show'); }, ms || 2400);
  };

  /* ---------- reveal (elements are visible at rest; this only adds a lift-in) ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 }) : null;
  HB.reveal = function (root) {
    var els = $$('.reveal', root || document);
    if (root && root.classList && root.classList.contains('reveal')) els.push(root);
    els.forEach(function (el) {
      if (!io || el.getBoundingClientRect().top < innerHeight) el.classList.add('in'); else io.observe(el);
    });
  };

  /* ---------- body scroll lock (cart drawer, mobile menu) ---------- */
  HB.lock = function (on) { document.body.classList.toggle('dr-lock', !!on); };

  /* ---------- 3D pouch mount ---------- */
  HB.mountPack = function (el, opts) {
    try { return el && window.HeyBearMount && window.THREE ? window.HeyBearMount(el, opts) : null; } catch (e) { console.warn('[HeyBear] 3D pouch unavailable', e); return null; }
  };

  /* ---------- classic lolly illustrations: product metafield first, theme asset fallback ---------- */
  var lollyCache = {};
  HB.lolly = function (key) {
    var flavour = HB.flavour(key);
    if (flavour && flavour.classic) return Promise.resolve('<img src="' + String(flavour.classic).replace(/"/g, '&quot;') + '" alt="">');
    if (!lollyCache[key]) lollyCache[key] = fetch((window.HB_ASSET_BASE || '') + 'hb-lolly-' + key + '.svg').then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { return t.replace(/^\s*<\?xml[^>]*>/, ''); }).catch(function () { return ''; });
    return lollyCache[key];
  };

  /* ---------- GSAP helper ---------- */
  HB.gsapReady = function () {
    if (!(window.gsap && window.ScrollTrigger) || HB.reduce) return false;
    if (!HB._st) { gsap.registerPlugin(ScrollTrigger); HB._st = true; }
    return true;
  };

  /* ---------- section registry (works with the Shopify theme editor) ---------- */
  var inits = {};
  function run(el) {
    var name = el.getAttribute('data-hb-section');
    if (!inits[name] || el.__hbInit) return;
    el.__hbInit = true;
    try { el.__hbDestroy = inits[name](el) || null; } catch (e) { console.error('[HeyBear] ' + name + ' failed to start', e); }
  }
  HB.section = function (name, init) {
    inits[name] = init;
    $$('[data-hb-section="' + name + '"]').forEach(run);
  };
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hb-section]', e.target).forEach(run);
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-hb-section]', e.target).forEach(function (el) {
      if (typeof el.__hbDestroy === 'function') { try { el.__hbDestroy(); } catch (_) {} }
    });
  });


  /* ---------- product page: shared "current flavour" for the hb-product-* sections ---------- */
  HB.pdp = {
    key: null,
    current: function () {
      if (HB.pdp.key) return HB.pdp.key;
      var el = document.querySelector('[data-hb-flavour]'), k = el && el.getAttribute('data-hb-flavour'), hasPageProduct = !!k;
      var D = HB.data(), h = (location.hash || '').slice(1);
      var byHash = D.flavours.filter(function (f) { return f.k3 === h; })[0];
      if (byHash && (!k || HB.flavour(k) && HB.flavour(k).demo)) k = byHash.key;
      if (!k || (!hasPageProduct && !HB.flavour(k))) k = (D.flavours[0] || {}).key;
      return (HB.pdp.key = k);
    },
    set: function (k) { if (!HB.flavour(k)) return; HB.pdp.key = k; document.dispatchEvent(new CustomEvent('hb:flavour', { detail: k })); },
    /* fn(flavourKey, flavourData) now and on every change; returns an unsubscribe function */
    on: function (fn) {
      var h = function (e) { fn(e.detail, HB.flavour(e.detail)); };
      document.addEventListener('hb:flavour', h);
      var k = HB.pdp.current(); if (k) fn(k, HB.flavour(k));
      return function () { document.removeEventListener('hb:flavour', h); };
    },
    /* switch flavour in place (same as the approved design); the address bar follows the real product URL */
    go: function (k) {
      var f = HB.flavour(k); if (!f || k === HB.pdp.current()) return;
      try { if (f.url && !f.demo) history.pushState({ hbFlavour: k }, '', f.url); else history.replaceState(null, '', '#' + f.k3); } catch (e) {}
      HB.pdp.set(k);
    },
    /* "imagine a green sour strap… with protein" -> "a green sour strap" */
    word: function (f) { var w = String((f && f.line) || '').replace(/^\s*imagine\s+/i, '').replace(/\s*(…|\.\.\.).*$/, '').trim(); return w || (f && f.word) || ''; }
  };

  /* back/forward after an in-place flavour switch: load that product page properly */
  window.addEventListener('popstate', function () { if (HB.pdp.key && document.querySelector('[data-hb-flavour]')) location.reload(); });

  /* ---------- Shopify cart (AJAX Cart API) ---------- */
  function emit(cart) { document.dispatchEvent(new CustomEvent('hb:cart:updated', { detail: cart })); }
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var err = new Error(d.description || d.message || 'Cart error'); err.data = d; throw err; } return d; });
    });
  }
  HB.cart = {
    state: null,
    get: function () { return json(HB.routes.cart + '.js').then(function (c) { HB.cart.state = c; emit(c); return c; }); },
    /* items: [{ id: variantId, quantity: n, selling_plan?: id, properties?: {} }] */
    add: function (items) {
      items = (items || []).filter(function (i) { return i && i.id; });
      if (!items.length) { HB.toast('These bears are not on sale yet. Check back soon.'); return Promise.reject(new Error('no variant')); }
      return json(HB.routes.cartAdd + '.js', { items: items }).then(function () { return HB.cart.get(); })
        .catch(function (e) { HB.toast(e.message || 'Could not add to cart'); throw e; });
    },
    change: function (key, quantity) {
      return json(HB.routes.cartChange + '.js', { id: key, quantity: quantity }).then(function (c) { HB.cart.state = c; emit(c); return c; })
        .catch(function (e) { HB.toast(e.message || 'Could not update cart'); throw e; });
    },
    /* updates: { lineItemKey: quantity }. Used when a cart rule must adjust
       several related lines atomically (for example removing dependent
       add-ons when their qualifying product leaves the cart). */
    update: function (updates) {
      return json(HB.routes.cartUpdate + '.js', { updates: updates || {} }).then(function (c) { HB.cart.state = c; emit(c); return c; })
        .catch(function (e) { HB.toast(e.message || 'Could not update cart'); throw e; });
    },
    open: function () { document.dispatchEvent(new CustomEvent('hb:cart:open')); }
  };
  HB.cartTotal = function () { return (HB.cart.state && HB.cart.state.total_price) || 0; };

  /* flying gummy from a button to the cart button (as in the approved design) */
  HB.flyToCart = function (fromEl, colour) {
    var cb = $('#cartBtn');
    if (cb) { cb.classList.remove('bump'); void cb.offsetWidth; cb.classList.add('bump'); }
    if (!window.gsap || HB.reduce || !fromEl || !cb) return 0;
    var g = document.createElement('div'); g.className = 'gummy';
    g.style.cssText = 'position:fixed;z-index:90;--w:50px;--c:' + (colour || '#8A5A33');
    g.innerHTML = '<svg viewBox="0 0 100 124"><use href="#bear"/></svg>';
    var a = fromEl.getBoundingClientRect(), b = cb.getBoundingClientRect();
    g.style.left = a.left + a.width / 2 - 25 + 'px'; g.style.top = a.top - 20 + 'px'; document.body.appendChild(g);
    gsap.to(g, { x: b.left - a.left - a.width / 2 + 40, y: b.top - a.top + 10, rotate: 300, scale: .4, duration: .45, ease: 'power2.in', onComplete: function () { g.remove(); } });
    /* Match the returned delay to the flight so callers can open the drawer
       as the gummy lands in the cart. */
    return 450;
  };

  /* load the cart once the page is ready */
  function boot() { HB.cart.get().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
